import React from 'react';
import '../styles/Payment.css'; // Create this CSS file for styling the Payment page
import QRCode from '../images/VenmoQRCode.png';

const Payment = () => {
    return (
        <div className="payment-page">
            <h1>Make a Payment</h1>
            <p>Please use the link or QR code below to make a payment to Sherri Richardson for the family reunion.</p>

            <div className="payment-details">
                <h3>Venmo Payment:</h3>
                <p>
                    Send payment to Sherri Richardson via Venmo using this link:
                    <a href="https://venmo.com/u/Sherri-Richardson-33" className="zelle-link">Pay Sherri via Venmo</a>
                </p>

                <div className="qr-code">
                    <img src={QRCode} alt="Venmo QR Code" />
                </div>
            </div>
            <br />
            <br />
            <p>Scan the QR code with your mobile device or click the link if you're on your phone to proceed with the payment.</p>

            <div className="check-payment-info">
                <h2>Pay by Check</h2>
                <p>We are now accepting checks for Family Reunion payments until March 11th.</p>
                <p>Please send your check to:</p>
                <address>
                    Sherri Richardson<br />
                    45 Solomon Hill Rd<br />
                    Milford, CT 06461
                </address>
                <p>Checks will be deposited the same day they are received.</p>
            </div>

            <div className="jotform-integration">
                <h2>Track Your Purchases</h2>
                <p>Please use the form below to select the items you have paid for. This helps us keep track of what has been purchased.</p>
                <div className="jotform-embed">
                    <iframe
                        title="Family Reunion Payment Form"
                        src="https://form.jotform.com/242446316599163"
                        width="100%"
                        height="2000"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </div>
    );
};

export default Payment;
